import React, { useEffect, useState, useCallback } from "react";
import { Controller, useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import CityList from "../../new_vehicles/cities_v1.json";
import InsurerName from "../../policy_wallet/dropdown.json";
import ErrorLabel from "../../../../../component/error_label";
import Newsletter from "../../../../../component/newsletter";
import OurApp from "../../../../../component/our_app";
import { useDropzone } from "react-dropzone";
import $ from "jquery";
import "flatpickr/dist/themes/material_green.css";
import Flatpickr from "react-flatpickr";
import moment from "moment";
import { actionAddPolicyWallet, resetAddPolicyWalletResponse } from "../store";
import {
  actionDropdown,
  resetDropdownDataResponse,
} from "../../../../../common/store";
import {
  TOAST_DURATION,
  TOAST_ERROR_COLOR,
  TOAST_POSITION,
  TOAST_SUCCESS_COLOR,
} from "../../../../../common/app_constant";
import toast from "react-hot-toast";
import Contact from "../../../../../component/contact";

const AddPolicyWallet = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { dropdownData } = useSelector((state) => ({
    ...state.commonStore,
  }));

  const { addPolicyWallet } = useSelector((state) => ({
    ...state.policyWalletStore,
  }));

  const {
    register,
    formState: { errors },
    handleSubmit,
    getValues,
    setValue,
    watch,
    control,
  } = useForm({
    defaultValues: {
      isSupport: "A",
      is_active: false,
      // allDropdownArr: null,
    },
  });

  const [attachment, setAttachment] = useState([]);
  // const allDropdownArr = watch('allDropdownArr')
  const startDate = watch("start_date");

  const [allDropdownArr, setAllDropdownArr] = useState({
    policy_type: [
      {
        id: 1,
        name: "Private Car Policy",
      },
      {
        id: 2,
        name: "Two-Wheeler Policy",
      },
      {
        id: 3,
        name: "Commercial Vehicle Policy ",
      },
      {
        id: 4,
        name: "Individual Health",
      },

      {
        id: 5,
        name: "Family Floater Health ",
      },
      {
        id: 6,
        name: "Personal Accident Policy",
      },
      {
        id: 7,
        name: "Super Top Up Insurance ",
      },
      {
        id: 8,
        name: "Unit Life Insurance",
      },

      {
        id: 9,
        name: "Endowment Plan",
      },
      {
        id: 10,
        name: "Shopkeeper policy",
      },
      {
        id: 11,
        name: "Home Insurance",
      },
      {
        id: 12,
        name: "Cyber Insurance",
      },
      {
        id: 13,
        name: "Term Life Insurance",
      },
      {
        id: 14,
        name: "Others",
      },
    ],
    insurer: [
      {
        id: 1,
        name: "ACKO GENERAL INSURANCE LIMITED",
      },
      {
        id: 2,
        name: "ADITYA BIRLA HEALTH INS. CO. LTD.",
      },
    ],
    city_state: [
      {
        id: 57,
        name: "DHAKA",
      },
      {
        id: 63,
        name: "PORT BLAIR",
      },
    ],
    document_type: [
      {
        key: "aadhar",
        value: "AADHAR CARD",
      },
      {
        key: "pan",
        value: "PAN CARD",
      },
    ],
  });

  useEffect(() => {
    if (getValues("is_active") === false) {
      setValue("is_active", true);
      dispatch(actionDropdown());
    }
  }, []);

  useEffect(() => {
    if (addPolicyWallet !== null) {
      dispatch(resetAddPolicyWalletResponse());
      if (addPolicyWallet.status === true) {
        toast.success(addPolicyWallet.message, {
          duration: TOAST_DURATION,
          position: TOAST_POSITION,
          style: {
            color: TOAST_SUCCESS_COLOR,
          },
        });
        navigate(-1);
      } else {
        switch (addPolicyWallet.status_code) {
          case 422:
            toast.error(addPolicyWallet.message, {
              duration: TOAST_DURATION,
              position: TOAST_POSITION,
              style: {
                color: TOAST_ERROR_COLOR,
              },
            });
            localStorage.clear();
            navigate("/login");
            break;
          case 401:
            localStorage.clear();
            navigate("/login", { replace: true });
            break;
          default:
        }
      }
    }
  }, [addPolicyWallet]);

  useEffect(() => {
    if (dropdownData !== null) {
      dispatch(resetDropdownDataResponse());
      if (dropdownData.result === true) {
        // setValue('allDropdownArr', dropdownData.data)
        setAllDropdownArr(dropdownData.data);
      } else {
        switch (dropdownData.status_code) {
          case 401:
            localStorage.clear();
            navigate("/login", { replace: true });
            break;
          default:
        }
      }
    }
  }, [dropdownData]);

  const generatePolicyType = () => {
    var menu = [];
    if (allDropdownArr != null && allDropdownArr.policy_type.length > 0) {
      allDropdownArr.policy_type.forEach(function (child, labelIndex) {
        menu.push(
          <option key={labelIndex} value={child.id}>
            {child.name}
          </option>
        );
      });
    }
    return menu;
  };
  const generateInsuranceCompany = () => {
    var menu = [];
    if (InsurerName != null && InsurerName.insurer_list.length > 0) {
      InsurerName.insurer_list.forEach(function (child, labelIndex) {
        menu.push(
          <option key={labelIndex} value={`${child.id}-${child.insurer_name}`}>
            {child.insurer_name}
          </option>
        );
      });
    }
    return menu;
  };

  const generateCity = () => {
    var menu = [];

    if (CityList.rto_json != null && CityList.rto_json.length > 0) {
      let cities= CityList.rto_json ;
      cities.forEach(function (child, labelIndex) {
          menu.push(
            <option key={child.id} value={child.Id}>
              {child.City}
            </option>
          );
      });
    }
    return menu;
  };

  const onDrop = useCallback((acceptedFiles) => {
    $("#order_attachment_error").removeClass("text-danger");
    if (attachment.length < 1) {
      setAttachment([...attachment, ...acceptedFiles]);
    } else {
    }
  });

  const { getRootProps, getInputProps, fileRejections } = useDropzone({
    accept: {
      doc_type: [".txt, .pdf, .doc, .docx, .jpeg, .jpg, .png, .xls, .xlsx "],
    },
    multiple: true,
    // maxFiles: 1,
    maxSize: 5242880,
    onDrop,
  });

  const fileRejectionItems = fileRejections.map(({ file, errors }) => (
    <ul className="danger" style={{ paddingInlineStart: "0px" }}>
      {errors.map((e) => (
        <li key={e.code}>{e.message}</li>
      ))}
    </ul>
  ));

  const removeFile = (file) => () => {
    const newFiles = [...attachment];
    newFiles.splice(newFiles.indexOf(file), 1);
    setAttachment(newFiles);
  };

  const removeAll = () => {
    setAttachment([]);
  };
  const thumbs = attachment.map((file) => (
    <>
      <div className="card mt-3" key={file.name}>
        <div className="card-body d-flex justify-content-between">
          <span className="my-auto"> {file.name} </span>
          <button
            type="reset"
            className="btn btn-sm btn-primary"
            onClick={removeFile(file)}
          >
            X
          </button>
        </div>
      </div>
    </>
  ));

  const onSubmit = async (data) => {
    var insurername = data.insurer_id;
    var insurernamesplit = insurername.split("-");
    var insurer_id = insurernamesplit[0];
    var insured_name = data.insured_name;

    var input = {
      policy_type_id: data.policy_type_id,
      policy_no: data.policy_no,
      start_date: moment(data.start_date, "DD-MM-YYYY").format("YYYY-MM-DD"),
      end_date: moment(data.end_date, "DD-MM-YYYY").format("YYYY-MM-DD"),
      premium: data.premium,
      insurer_id: insurer_id,
      insured_name: insured_name,
      city_id: data.city_id,
      remark: data.remark,
    };
    var files = [];
    attachment.forEach((objImage, index) => {
      if (objImage != null) {
        files.push({
          name: "file",
          value: objImage,
        });
      }
    });
    dispatch(actionAddPolicyWallet({ input, files }));
  };
  return (
    <>
      <div className="row py-5">
        <div className="col-12">
          <nav className="--bs-breadcrumb-divider" aria-label="breadcrumb">
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <a
                  onClick={() => {
                    // navigate("/dashboard");
                  }}
                >
                  Dashboard
                </a>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                Policy Wallet
              </li>
            </ol>
          </nav>
        </div>
        <div className="col-12 col-md-8">
          <div className="row">
            <div className="col-12">
              <div className="card profile-section">
                <div className="card-body">
                  <form
                    noValidate
                    autoComplete="off"
                    onSubmit={handleSubmit(onSubmit)}
                  >
                    <div className="row">
                      <div className="col-md-6 mt-3">
                        <label htmlFor="policyType" className="form-label">
                          Policy Type<span className="text-danger">*</span>
                        </label>
                        <select
                          id="policy_type_id"
                          className="form-control form-select"
                          {...register("policy_type_id", {
                            required: "This is required.",
                          })}
                        >
                          <option value="">Policy Type</option>
                          {generatePolicyType()}
                        </select>
                        {errors.policy_type_id && (
                          <ErrorLabel
                            message={errors.policy_type_id?.message}
                          />
                        )}
                      </div>
                      <div className="col-md-6 mt-3">
                        <label className="form-label">Policy No</label>
                        <input
                          type="text"
                          className="form-control"
                          name="policy_no"
                          {...register("policy_no", {
                            required: "This is required.",
                            minLength: {
                              value: 6,
                              message:
                                " Policy No cannot be less than 6-chars.",
                            },
                            maxLength: {
                              value: 30,
                              message:
                                " Policy No cannot be greater than 30-chars.",
                            },
                          })}
                        />
                        {errors.policy_no && (
                          <ErrorLabel message={errors.policy_no?.message} />
                        )}
                      </div>
                      <div className="col-md-6 mt-3">
                        <label className="form-label">
                          Insured Name <span className="text-danger">*</span>{" "}
                        </label>
                        <input
                          type="text"
                          name="insured_name"
                          className="form-control"
                          {...register("insured_name", {
                            required: "Insurer Name is Required",
                          })}
                        />
                        {errors.insured_name && (
                          <ErrorLabel message={errors.insured_name?.message} />
                        )}
                      </div>
                      <div className="col-md-6 mt-3">
                        <div class="form-group has-search">
                          <label className="form-label">
                            Start Date<span className="text-danger">*</span>
                          </label>
                          <span class="fa fa-calendar form-control-feedback"></span>
                          <Controller
                            name="start_date"
                            control={control}
                            render={({ field }) => (
                              <Flatpickr
                                {...field}
                                onChange={(value) => {
                                  var date = new Date(value).toISOString();
                                  setValue(
                                    "start_date",
                                    moment(date).format("DD-MM-YYYY")
                                  );
                                }}
                                id="disabled-picker"
                                className="form-control"
                                options={{
                                  dateFormat: "d-m-Y",
                                  // minDate: 'today',
                                  maxDate: "today",
                                  enableTime: false,
                                }}
                              />
                            )}
                            rules={{
                              required: "This is required.",
                            }}
                          />
                          {errors.start_date && (
                            <ErrorLabel message={errors.start_date?.message} />
                          )}
                        </div>
                      </div>
                      <div className="col-md-6 mt-3">
                        <div class="form-group has-search">
                          <label className="form-label">
                            Renewal Date<span className="text-danger">*</span>
                          </label>
                          <span class="fa fa-calendar form-control-feedback"></span>
                          <Controller
                            name="end_date"
                            control={control}
                            render={({ field }) => (
                              <Flatpickr
                                {...field}
                                onChange={(value) => {
                                  var date = new Date(value).toISOString();
                                  setValue(
                                    "end_date",
                                    moment(date).format("DD-MM-YYYY")
                                  );
                                }}
                                id="disabled-picker"
                                className="form-control"
                                options={{
                                  dateFormat: "d-m-Y",
                                  minDate: startDate,
                                  enableTime: false,
                                }}
                              />
                            )}
                            rules={{
                              required: "This is required.",
                            }}
                          />
                          {errors.end_date && (
                            <ErrorLabel message={errors.end_date?.message} />
                          )}
                        </div>
                      </div>
                      <div className="col-md-6 mt-3">
                        <label htmlFor="policyType" className="form-label">
                          Insurance Company
                          <span className="text-danger">*</span>
                        </label>
                        <select
                          id="insurer_id"
                          className="form-control form-select"
                          {...register("insurer_id", {
                            required: "This is required.",
                          })}
                        >
                          <option value="">Insurance Company</option>
                          {generateInsuranceCompany()}
                        </select>
                        {errors.insurer_id && (
                          <ErrorLabel message={errors.insurer_id?.message} />
                        )}
                      </div>
                      <div className="col-md-6 mt-3">
                        <label className="form-label">Premium</label>
                        <input
                          type="text"
                          className="form-control"
                          name="premium"
                          onKeyDown={(event) => {
                            if (!/[0-9]|Backspace|Delete|ArrowLeft|ArrowRight|Home|End/.test(event.key)) {
                              event.preventDefault();
                            }
                          }}
                          {...register("premium", {
                            required: "This is required.",
                          })}
                        />
                        {errors.premium && (
                          <ErrorLabel message={errors.premium?.message} />
                        )}
                      </div>
                      <div className="col-md-6 mt-3">
                        <label htmlFor="city_id" className="form-label">
                          City
                        </label>
                        <select
                          id="city_id"
                          name="city_id"
                          className="form-control form-select"
                          {...register("city_id", {})}
                        >
                          <option value="">City</option>
                          {generateCity()}
                        </select>
                      </div>
                      <div className="col-md-6 mt-3">
                        <label className="form-label">
                          Remark<span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="remark"
                          {...register("remark", {
                            required: "Remark is required",
                            maxLength: {
                              value: 200,
                              message: "Remark is allowed upto 200 characters",
                            },
                          })}
                        />
                        {errors.remark && (
                          <ErrorLabel message={errors.remark?.message} />
                        )}
                      </div>
                      <div className="col-12 mt-4">
                        <div
                          {...getRootProps({ className: "dropzone" })}
                          className="border-dashed text-center p-3 bg-light rounded border-secondary shadow"
                        >
                          <span className="badge bg-primary rounded p-2">
                            <input accept="" {...getInputProps()} />
                            <i className="fa fa-plus" />
                          </span>{" "}
                          <span>Add files</span>
                        </div>
                        {thumbs}
                        {attachment.length > 1 && (
                          <button
                            type="btn"
                            className="btn btn-primary rounded mt-4"
                            onClick={(e) => {
                              e.preventDefault();
                              removeAll();
                            }}
                          >
                            Remove All
                          </button>
                        )}
                        {fileRejectionItems}
                      </div>
                      <div className="col-12 mt-3">
                        <button
                          id="submit"
                          name="submit"
                          type="submit"
                          className="btn btn-primary"
                        >
                          Submit
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-12 col-md-4">
          <Contact />
        </div>
      </div>
    </>
  );
};

export default AddPolicyWallet;
